<template>
<!-- 考试卡片 -->
  <div class="test-card g-rela">
<!--    <div class="free-tag g-flex g-row-center">免费</div>-->
    <div class="g-p-15 g-rela">
      <div class="g-rela" @mouseenter="doAnimate" @mouseleave="endAnimate">
        <div class="mask g-flex g-row-center" v-if="isHover" @click="goDetail">
          <div class="submit-btn g-flex g-row-center animate__animated animate__bounceIn">立即考试</div>
        </div>
        <img :src="data.coverPath" class="poster"  alt=""/>
      </div>
      <div class="g-m-t-15 g-show-2-line test-name">
        {{ data.paperName }}
      </div>
      <div class="g-flex g-row-between g-m-t-15">
        <p class="remark-text g-font-14">{{ data.examNum }}人已考</p>
        <div class="level-tag g-font-14">
          {{ data.level }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "test-card",
  props:{
    data:{
      type:Object,
    }
  },
  data(){
    return{
      isHover:false,
    }
  },
  methods:{
    //鼠标移入的事件
    doAnimate(){
      setTimeout(()=>{
        this.isHover = true
      },100)
    },
    //  鼠标移除事件
    endAnimate(){
      setTimeout(()=>{
        this.isHover = false
      },100)
    },
    //  立即考试
    goDetail(){
      this.$router.push({
        name:'examination-detail',
        query: {
          id:this.data.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .test-card{
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 10px 0 rgba(64,122,255,0.10);
    width: 285px;
    height: 370px;
    .poster{
      width: 255px;
      height: 235px;
      border-radius: 5px;
      background: #1788ff;
    }

    .level-tag{
      color: #fff;
      background: #1788ff;
      border-radius: 20px;
      padding: 2px 14px;
    }

    .free-tag{
      background-image: url("../assets/home/free-tag.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 72px;
      height: 33px;
      position: absolute;
      right: -1px;
      top: -6px;
      color: #fff;
      font-size: 12px;
      z-index: 97;
    }
  }

  .mask{
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 255px;
    height: 235px;
    border-radius: 5px;
    cursor: pointer;
  }

  .submit-btn{
    padding: 3px 12px;
  }

  .test-name{
    letter-spacing: 1px;
    line-height: 24px;
    color: #333;
  }
</style>